import r from "./ghl-ui.es1433.js";
var a = r();
const o = a;
export {
  o as default
};
